<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5"></a>For Nathalie, who liked the idea<br/>of Adelrune going to knight school</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half_dedication.vue?41aefaeb